import { z } from 'zod';
import { Notification } from './notification.js';
import { NotificationKnownKind, NotificationPreference } from './preferences.js';
export const NotificationResponse = z.object({
    notification: Notification,
    unreadCount: z.number().int().nonnegative(),
});
export const NotificationListResponse = z.object({
    notifications: z.array(Notification),
    total: z.number().int().nonnegative(),
    unreadCount: z.number().int().nonnegative(),
    limit: z.number().int().nonnegative(),
    offset: z.number().int().nonnegative(),
});
export const MarkAllReadResponse = z.object({
    updated: z.number().int().nonnegative(),
    unreadCount: z.number().int().nonnegative(),
});
export const NotificationPreferencesResponse = z.object({
    kinds: z.array(NotificationKnownKind),
    preferences: z.array(NotificationPreference),
});
//# sourceMappingURL=responses.js.map